export const normalizedArray = (
  array = [],
  keys = { keyValue: "", keyLabel: "", keySecondLabel: "" },
  dobleLabel = false
) => {
  return array.map((item) => {
    return {
      value: item[keys.keyValue],
      label: `${item[keys.keyLabel]}${dobleLabel ? " - " : ""}${
        item[keys.keySecondLabel] ? item[keys.keySecondLabel] : ""
      }`,
    };
  });
};
